import './timelineDotLine.scss'

const TimelineDotLine = ({ color = '#00b85f', children }) => (
  <div className="timeline-dot-line">
    <div className="timeline-dot-line-bar-container">
      <div className="timeline-dot-line-bar" style={{ backgroundColor: color }} />
      <div className="timeline-dot-line-dot" style={{ backgroundColor: color }} />
    </div>
    {children}
  </div>
)

export default TimelineDotLine
